import Vue from 'vue'

Vue.filter('pluralize', (num, plural, singular) => {
  return num === 1 ? singular : plural
})

Vue.filter('formatCurrency', (sum) => {
  sum = (parseFloat(sum)).toFixed(2)

  return 'kr ' + (sum + '').replace('.', ',')
})
